import React, { useState, useEffect } from "react";
import "./comparison.css";
import Meta from "utils/meta";
import ZohoFeatures from "utils/ComparionData/zohoFeatures";
import ZohoDetailedFeatures from "utils/ComparionData/zohoDetailedFeatures";
import SubPageHeader from "Component/SubPageHeader/subPageHeader";
import ComparisonTopTabs from "Component/ComparisonTopTabs/ComparisonTopTabs";
import ComparisonSideMenu from "Component/ComparisonSideMenu/ComparisonSideMenu";
import ComparisonFeatures from "Component/ComparisonFeatures/ComparisonFeatures";
import ComparisonSalientFeatures from "Component/ComparisonSalientFeatures/ComparisonSalientFeatures";
import DetailedComparisonTable from "Component/ComparisonFeatures/DetailedComparisonTable";

const Zoho = () => {
  const sideMenu = [
    {name: "Best Real Estate CRM", link: "top-intro-section"},
    {name: "Features: Realtor vs Zoho", link: "comparison-features-section"},
    {name: "Salient Features", link: "comparison-salient-features"},
    {name: "Detailed Comparison", link: "detailed-comparison"}
  ];
  const [activeDetailedComparison, setActiveDetailedComparison] = useState([]);

  const handleDetailedComparisonTab = (index) => {
    if (activeDetailedComparison.includes(index)) {
      setActiveDetailedComparison(activeDetailedComparison.filter(item => item !== index));
    } else {
      setActiveDetailedComparison([...activeDetailedComparison, index]);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<>
      <Meta title="Zoho | The Realtor Desk" description="" />
      <div className="sub-page--outer">
        <SubPageHeader
            title="Realtor Real Estate: A CRM with Easy-to-Use & Real Estate Specific Features"
            subTitle="Realtor Real Estate has been designed and developed exclusively for the real Estate industry. It has industry-specific features like Inventory Management."
        />
        <ComparisonTopTabs
            activeTab={3}
        />
        <div className="container comparison-outer">
          <div className="comp-side--menu">
            <h4>Comparison Tools</h4>
            <ComparisonSideMenu
                sideMenu={sideMenu}
                currentActive={sideMenu[0].link}
            />
          </div>
          <div className="comp-side--content">
            <div className="top-title-section" id="top-intro-section">
              <h4>A CRM with Easy-to-Use & Real Estate Specific Features</h4>
              <p>Realtor Real Estate has been designed and developed exclusively for the real Estate industry. It has industry-specific features like Inventory Management, Channel Partner Management, offers seamless integration with multiple tools as well as Post-Sales Management. What’s more, in comparison to Zoho, Realtor is easier to use because of simplified dashboards, clean interfaces and comes with an app for on-the-go access.</p>
            </div>
            <ComparisonFeatures
                features={ZohoFeatures}
                title="Better Real Estate with Realtor Features"
                platform="Zoho"
            />
            <ComparisonSalientFeatures
                title="Salient Feature of Realtor Real Estate : An Alternative to Zoho CRM for Real Estate"
            />
            <div className="detailed-comparison-section--outer" id="detailed-comparison">
              <h4>How Realtor Real Estate is a Better Alternative to Zoho</h4>
              <div className="comparison-table--accordion">
                {ZohoDetailedFeatures.map((singleFeature, index) => (
                    <div key={index} className="comparison--accordion-item">
                      <div className={`comparison--accordion-title ${activeDetailedComparison.includes(index) ? "active-title" : ""}`} onClick={() => handleDetailedComparisonTab(index)}>
                        <span>{singleFeature.tab_heading}</span>
                        {activeDetailedComparison.includes(index) ? (<i className="fa fa-minus" />) : (<i className="fa fa-plus" />)}
                      </div>
                      {activeDetailedComparison.includes(index) && (
                          <DetailedComparisonTable
                              features={singleFeature.tab_info}
                              platform="Zoho"
                          />
                      )}
                    </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Zoho;
